export default "__VITE_ASSET__BvybXaHp__"